import config from '../config';

const TokenService = {
  saveAuthToken(token) {
    // console.log("save token")
    window.localStorage.setItem(config.TOKEN_KEY, token);
  },
  getAuthToken() {
    // console.log("get token")
    return window.localStorage.getItem(config.TOKEN_KEY);
  },
  clearAuthToken() {
    // console.log("clear auth")
    window.localStorage.clear();
  },
  hasAuthToken() {
    // console.log("has auth?")
    return !!TokenService.getAuthToken();
  },
  hasNewAuthToken() {
    // console.log("has auth?")
    return !!TokenService.getNewAuthToken();
  },
  makeBasicAuthToken(userName, password) {
    return window.btoa(`${userName}:${password}`);
  },
  saveNewAuthToken(token) {
    window.localStorage.setItem("swhtoken", token);
  },
  getNewAuthToken() {
    return window.localStorage.getItem("swhtoken");
  },
};

export default TokenService;
